import { getMeta, site, safeJson } from './site.cjs';

function setMeta(key, content, property = false) {
  const attr = property ? 'property' : 'name';
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) return el?.remove();
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function applySeo(path) {
  if (typeof document === 'undefined') return;
  const meta = getMeta(path);
  document.title = meta.title;
  const named = {
    description: meta.description,
    robots: meta.robots,
    googlebot: meta.robots,
    'twitter:card': 'summary_large_image',
    'twitter:title': meta.title,
    'twitter:description': meta.description,
    'twitter:image': meta.image,
    'twitter:image:alt': meta.imageAlt,
  };
  const properties = {
    'og:type': 'website',
    'og:site_name': site.name,
    'og:locale': 'de_CH',
    'og:title': meta.title,
    'og:description': meta.description,
    'og:image': meta.image,
    'og:image:alt': meta.imageAlt,
    'og:url': meta.canonical,
  };
  for (const [key, value] of Object.entries(named)) setMeta(key, value);
  for (const [key, value] of Object.entries(properties)) setMeta(key, value, true);
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (meta.canonical) {
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = meta.canonical;
  } else canonical?.remove();
  let schema = document.getElementById('site-schema');
  if (meta.schema) {
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'site-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }
    schema.textContent = safeJson(meta.schema);
  } else schema?.remove();
}
